# If parallel system tests fail, try to run remove public/packs-tests first and then run system tests without parallelization.
# It should compile assets correctly and then you can run system tests in parallerl...
TROUBLE_TICKET_TYPE_PROBLEM_REPORT = 2
TROUBLE_TICKET_STATE_OPEN_ID = 2
TROUBLE_TICKET_STATE_CLOSED_ID = 3

class TroubleTicketsController

  @row_attr: (trouble_ticket) ->
    classes = ['row']
    if trouble_ticket.get('type_id') == TROUBLE_TICKET_TYPE_PROBLEM_REPORT
      if trouble_ticket.get('state_id') == TROUBLE_TICKET_STATE_OPEN_ID
        classes.push('problem_report open')
      else
        classes.push('problem_report closed')
    else if trouble_ticket.get('state_id') == TROUBLE_TICKET_STATE_CLOSED_ID
      classes.push('silver')

    ' class="' + classes.join(' ') + '"'

module.exports = TroubleTicketsController
